import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter035() {
  return <KbChapterPage slug="chapter-035" />;
}

(Chapter035 as unknown as { path: string }).path = "/theory-album/035";
